import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import circuit from '../../assests/pcb.png';
import pcb from '../../assests/circuit.png';
import embedded from '../../assests/website.png';
import app from '../../assests/app.png';
import web from '../../assests/embeded.png';
import ad from '../../assests/ad.png';
import cad from '../../assests/cad.png';
import graphic from '../../assests/curve (1).png';
import logo from '../../assests/logo-design.png';
import './Services.css';

const services = [
  ['circuit-design', 'Custom Circuit Designs', circuit],
  ['pcb-design', 'PCB Design', pcb],
  ['embedded-programming', 'Embedded Programming', embedded],
  ['app-development', 'App Development', app],
  ['web-development', 'Web Development', web],
  ['advertisement', 'Social Media Advertisement', ad],
  ['cad-design', 'CAD Design', cad],
  ['graphic-design', 'Graphic Design', graphic],
  ['logo-design', 'Logo Design', logo],
];
export default function Services() {
  const { t, i18n } = useTranslation();
  const en = i18n.language.startsWith('en');
  return (
    <section className="services-section" aria-labelledby="services-title">
      <div className="services-container">
        <div className="services-header">
          <span className="eyebrow">{en ? 'TECHNOLOGY MEETS CREATIVITY' : 'TEKNIK MÖTER KREATIVITET'}</span>
          <h2 id="services-title">{t('Our Services')}</h2>
          <p>{en ? 'From a first sketch to a working solution. Find the expertise your project needs.' : 'Från en första skiss till en fungerande lösning. Hitta kompetensen för ditt projekt.'}</p>
        </div>
        <div className="services-cards">
          <Link className="service-card service-card-printing" to="/3d-printing">
            <span className="service-3d-icon" aria-hidden="true">⬡</span>
            <span className="service-text">{en ? '3D printing' : '3D-utskrift'}</span>
            <span className="service-card-detail">{en ? 'Ideas you can hold.' : 'Idéer du kan hålla i.'}</span>
            <span className="service-arrow" aria-hidden="true">↗</span>
          </Link>
          {services.map(([path, label, icon]) => (
            <Link className="service-card" to={'/' + path} key={path}>
              <img src={icon} alt="" width="80" height="80" loading="lazy" />
              <span className="service-text">{t(label)}</span>
              <span className="service-arrow" aria-hidden="true">↗</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
